var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAddressIcon = function SvgAddressIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8E8E93",
    fillRule: "evenodd",
    d: "M20 4c5.854 0 11 4.848 11 10.5 0 1.481-.47 3.174-1.35 5.07-.875 1.885-2.099 3.854-3.48 5.867a173 173 0 0 1-2.86 4.006q-.714.979-1.418 1.958A87 87 0 0 0 20 34.126a87 87 0 0 0-1.892-2.725q-.704-.98-1.42-1.958c-.962-1.322-1.928-2.649-2.859-4.006-1.381-2.013-2.604-3.982-3.48-5.868C9.472 17.673 9 15.981 9 14.5 9 8.848 14.147 4 20 4m4.905 26.652c-1.358 1.864-2.669 3.664-3.733 5.344-.437.69-.832 1.359-1.171 2.004a29 29 0 0 0-1.172-2.004c-1.064-1.68-2.375-3.48-3.733-5.345C11.236 25.352 7 19.537 7 14.5 7 7.644 13.145 2 20 2c6.857 0 13 5.644 13 12.5 0 5.037-4.235 10.852-8.095 16.152M25 15a5 5 0 1 1-10 0 5 5 0 0 1 10 0m2 0a7 7 0 1 1-14 0 7 7 0 0 1 14 0",
    clipRule: "evenodd"
  })));
};
export default SvgAddressIcon;